import { useLanguage } from "@/context/LanguageContext";

export const LanguageToggle = ({ className = "" }) => {
  const { lang, setLang, t } = useLanguage();
  return (
    <div
      role="group"
      aria-label={t.nav.langLabel}
      data-testid="language-toggle"
      className={`inline-flex items-center rounded-full border border-[var(--line-strong)] bg-black/30 p-0.5 font-mono text-[11px] tracking-wider ${className}`}
    >
      {["de", "en"].map((code) => {
        const active = lang === code;
        return (
          <button
            key={code}
            type="button"
            onClick={() => setLang(code)}
            data-testid={`lang-${code}`}
            aria-pressed={active}
            className={`rounded-full px-2.5 py-1 uppercase transition-colors ${
              active ? "bg-[var(--ink)] text-[#0b0e0b]" : "text-[var(--ink-2)] hover:text-white"
            }`}
          >
            {code}
          </button>
        );
      })}
    </div>
  );
};
